<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-form ref="productForm" v-model="formValid">
        <v-layout row wrap pa-2>
          <v-flex lg4 md4 sm12>
            <v-autocomplete
              v-model="currentItem.UID"
              :items="customers"
              :item-text="u => u.Username + ' - ' + u.FullName"
              item-value="ID"
              label="Khách hàng / 唛头"
              clearable
              outlined dense
              :disabled="!editableRole"
            ></v-autocomplete>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <v-text-field
              v-model="currentItem.DirectName"
              :label="'Điều hướng / 目的地'"
              outlined dense
              persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <v-text-field
              v-model="currentItem.ProductNameVN"
              :label="'Tên hàng / 货名'"
              outlined dense
              persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-select
              v-model="currentItem.ProductType"
              :items="filteredProductTypes"
              :item-text="u => `${u.ShortName}-${u.Name}`"
              item-value="ID"
              :label="'Loại hàng / 货物类型'"
              outlined dense
              :disabled="!currentItem.UID || !editableRole"
            ></v-select>
          </v-flex>
          <v-flex lg6 md6 sm12>
            <v-text-field
              v-model="currentItem.SuffixBill"
              :label="'Mã bốc / 装货编号'"
              outlined dense
              persistent-hint
              :rules="[v => !!v || 'Mã bốc là bắt buộc']"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap pa-2>
          <v-flex lg4 md4 sm12>
            <h-currency-input
              v-model="currentItem.ExchangeRate"
              label="Tỷ giá / 汇率"
              :decimal="0"
            ></h-currency-input>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <h-currency-input
              v-model="currentItem.WeightPrice"
              label="Giá cân / 重量单价"
              :decimal="0"
            ></h-currency-input>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <h-currency-input
              v-model="currentItem.VolumePrice"
              label="Giá khối / 体积单价"
              :decimal="0"
            ></h-currency-input>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <h-currency-input
              v-model="currentItem.NumberOfPack"
              :label="'Số kiện / 件数'"
              :decimal="0"
              readonly
            ></h-currency-input>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <h-currency-input
              v-model="currentItem.Weight"
              :label="'Cân nặng / 重量'"
              :decimal="1"
              readonly
            ></h-currency-input>
          </v-flex>
          <v-flex lg4 md4 sm12>
            <h-currency-input
              v-model="currentItem.Volume"
              :label="'Thể tích / 体积'"
              :decimal="2"
              readonly
            ></h-currency-input>
          </v-flex>
        </v-layout>
        
        <v-layout row wrap pa-6>
          <v-flex lg12 md12 sm12>
            <v-layout row wrap justify-space-between pr-1>
              <v-toolbar-title class="subheading">Danh sách mã wuliu / 运单号列表</v-toolbar-title>
              <v-btn class="mx-2" dark small color="primary" :disabled="!(adminRole || currentItem.Status == product_status.nhap_kho_tq)" @click="openDialogWuliu">
                <v-icon dark>add</v-icon> Thêm wuliu / 添加物流
              </v-btn>
            </v-layout>
          </v-flex>
          <v-flex lg12>
            <v-data-table 
              :headers="wuliu_header" 
              :items="productWulius" 
              hide-default-footer 
              disable-pagination
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.TransactionCode }}</td>
                  <td>{{ item.ProductName }}</td>
                  <td>{{ item.ProductTypeName }}</td>
                  <td>{{ item.Status | display_value(product_status_list) }}</td>
                  <td class="text-right">{{ item.Weight | currency('', 1) }}</td>
                  <td class="text-right">{{ item.Volume | currency('', 3) }}</td>
                  <td class="text-right">{{ item.Qty }}</td>
                  <td class="text-right">{{ item.Deposit | currency('', 1) }}</td>
                  <td class="text-center">
                    <v-icon small class="mr-2" @click="editWuliu(item)" :disabled="!(adminRole || currentItem.Status == product_status.nhap_kho_tq)">edit</v-icon>
                    <v-icon small @click="deleteWuliu(item.ID)" :disabled="!(adminRole || currentItem.Status == product_status.nhap_kho_tq)">delete</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        </v-form>
      </v-card>
    </v-container>

    <!-- System Logs Section -->
    <v-container grid-list-xl fluid v-if="currentItem.ID">
      <v-card>
        <v-card-title>
          <span class="subtitle-1">Nhật ký chỉnh sửa / 修改日志</span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="log_headers"
            :items="systemLogs"
            :loading="loadingLogs"
            disable-pagination
            hide-default-footer
            dense
          >
            <template v-slot:item.created_at="{ item }">
              {{ item.created_at | display_date }}
            </template>
            <template v-slot:item.content="{ item }">
              <div style="max-width: 400px; white-space: pre-wrap; font-size: 12px;">
                <span v-html="item.content"></span>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Dialog Wuliu Component -->
    <wuliu-dialog
      v-model="dialogWuliu"
      :exchange-rate="currentItem.ExchangeRate"
      :wuliu-id="editingWuliuId"
      :initial-data="newWuliu"
      @save="handleSaveWuliu"
      @close="handleCloseWuliu"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import { sendSuccessNotice, sendErrorNotice } from "@/commons/utils";
import _ from "lodash";
import WuliuDialog from "@/components/WuliuDialog";

export default {
  components: {
    WuliuDialog
  },
  data() {
    return {
      formValid: false,
      product_status_list: configs.PRODUCT_STATUS_LIST,
      product_status: configs.PRODUCT_STATUS,
      systemLogs: [],
      loadingLogs: false,
      filteredProductTypes: [],
      log_headers: [
        { text: 'Người dùng / 用户', value: 'user_name', width: '150px' },
        { text: 'Thời gian / 时间', value: 'created_at', width: '180px' },
        { text: 'Nội dung / 内容', value: 'content' },
      ],
      wuliu_header: [
        { text: 'Mã wuliu / 运单号', value: 'TransactionCode', sortable: false },
        { text: 'Tên hàng / 货名', value: 'ProductName', sortable: false },
        { text: 'Loại hàng / 货物类型', value: 'ProductTypeName', sortable: false },
        { text: 'Trạng thái / 状态', value: 'Status', sortable: false },
        { text: 'Cân nặng / 重量', value: 'Weight', align: 'end', sortable: false },
        { text: 'Thể tích (m³) / 体积', value: 'Volume', align: 'end', sortable: false },
        { text: 'Số lượng / 数量', value: 'Qty', align: 'end', sortable: false },
        { text: 'Chi tệ / 支出金额', value: 'Deposit', align: 'end', sortable: false },
        { text: '', value: '', align: 'center', width: '80px' },
      ],
      package_header: [
        { text: 'STT / 序号', value: 'index', width: '60px' },
        { text: 'Cân nặng (kg) / 重量', value: 'Weight', align: 'end', width: '120px' },
        { text: 'Dài (cm) / 长', value: 'Length', align: 'end', width: '100px' },
        { text: 'Rộng (cm) / 宽', value: 'Width', align: 'end', width: '100px' },
        { text: 'Cao (cm) / 高', value: 'Height', align: 'end', width: '100px' },
        { text: 'Số kiện / 件数', value: 'Qty', align: 'end', width: '100px' },
        { text: 'Thể tích (m³) / 体积', value: 'Volume', align: 'end', width: '120px' },
        { text: '', value: '', align: 'center', width: '60px' },
      ],
      dialogWuliu: false,
      editingWuliuId: null,
      newWuliu: {
        TransactionCode: '',
        ProductName: '',
        Weight: 0,
        Volume: 0,
        Qty: 0,
        Deposit: 0,
        packages: []
      },
      popupViewName: "popup_wuliu",
    };
  },
  computed: {
    ...mapState({
      loading: state => state.product.loading,
      currentItem: state => state.product.selected,
      customers: state => state.commons.customers,
      product_types: state => state.productType.all.data,
      productWulius: state => state.product.wuliuList.data,
    }),
    editableRole() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin || 
             this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Accountant;
    },
    adminRole() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
    },
    currentId() {
      return Number(this.$route.params.Pid);
    },
    selectedProductType() {
      const productTypeId = this.currentItem && this.currentItem.ProductType;
      if (!productTypeId) {
        return null;
      }
      return _.find(this.filteredProductTypes, { ID: productTypeId }) || _.find(this.product_types, { ID: productTypeId }) || null;
    }
  },
  watch: {
    currentItem() {
      // Load data when currentItem changes
      if (this.currentItem && this.currentItem.ID) {
        this.getProductWulius();
      }
    },
    'currentItem.UID': {
      handler(newUID) {
        if (newUID) {
          this.loadProductTypesByCustomer(newUID);
        } else {
          this.filteredProductTypes = [];
        }
      },
      immediate: true
    }
  },
  methods: {
    async loadProductTypesByCustomer(uid) {
      try {
        // Fetch product types available for this customer from fee_weight and fee_volume tables
        const response = await this.$store.dispatch("product/getProductTypesByCustomer", uid);
        if (response && response.data) {
          this.filteredProductTypes = response.data.map(p => ({
            ...p,
            disabled: p.IsLocked == 1 || p.IsLocked == true
          }));
        } else {
          this.filteredProductTypes = [];
        }
      } catch (err) {
        console.error('Error loading product types for customer:', err);
        this.filteredProductTypes = [];
      }
    },
    getDetail() {
      if (!this.currentId || this.currentId === 'new') {
        this.$store.commit("product/setDetail", { ID: 0, Status: 2 });
      } else {
        this.$store.dispatch("product/getDetail", this.currentId).then((ret) => {
          ret = ret.data ? ret.data : ret;
          if (_.isEmpty(ret)) {
            sendErrorNotice("Lỗi, không load được dữ liệu / 错误，无法加载数据。");
          } else {
            this.getSystemLogs();
          }
        });
      }
    },
    openDialogWuliu() {
      if (!this.currentItem.UID) {
        sendErrorNotice("Vui lòng chọn khách hàng trước / 请先选择客户");
        return;
      }
      if (!this.currentItem.SuffixBill) {
        sendErrorNotice("Vui lòng nhập Mã bốc trước / 请先输入装货编号");
        return;
      }
      
      this.editingWuliuId = null;
      this.newWuliu = {
        TransactionCode: '',
        ProductName: '',
        Weight: 0,
        Volume: 0,
        Qty: 0,
        Deposit: 0,
        packages: []
      };
      this.dialogWuliu = true;
    },
    editWuliu(wuliu) {
      this.editingWuliuId = wuliu.ID;
      this.dialogWuliu = true;
    },
    handleCloseWuliu() {
      this.dialogWuliu = false;
      this.editingWuliuId = null;
    },
    calculateProductTotals() {
      let totalWeight = 0;
      let totalVolume = 0;
      let totalQty = 0;
      
      this.productWulius.forEach(wuliu => {
        totalWeight += (wuliu.Weight || 0);
        totalVolume += (wuliu.Volume || 0);
        totalQty += (wuliu.Qty || 0);
      });
      
      this.currentItem.Weight = totalWeight;
      this.currentItem.Volume = totalVolume;
      this.currentItem.NumberOfPack = totalQty;
    },
    async handleSaveWuliu({ formData, editingWuliuId }) {
      // Save Product first if new
      const isNewProduct = !this.currentItem.ID;
      
      try {
        let productId = this.currentItem.ID;
        
        if (isNewProduct) {
          const p = await this.$store.dispatch("product/setDetail", {
            'data': {...this.currentItem},
            'id': 0
          });
          console.log("Created new product:", p);
          productId = p.ID || 0;
          // Update currentItem.ID immediately
          this.currentItem.ID = productId;
          this.$store.commit("product/setDetail", { ...this.currentItem });
        }
        
        // Create or Update Wuliu with packages
        const wuliuData = {
          TransactionCode: formData.TransactionCode,
          ProductName: formData.ProductName,
          Weight: formData.Weight,
          Volume: formData.Volume,
          Qty: formData.Qty,
          Deposit: formData.Deposit,
          TransactionDeposit: formData.TransactionDeposit,
          PedicabDeposit: formData.PedicabDeposit,
          LoadDeposit: formData.LoadDeposit,
          ReinforceDeposit: formData.ReinforceDeposit,
          UID: this.currentItem.UID,
          ProductType: this.currentItem.ProductType,
          ProductID: productId,
          Status: 0, // Mới tạo
          packages: JSON.stringify(formData.packages)
        };
        console.log("Saving Wuliu data:", wuliuData);
        await this.$store.dispatch("wuliu/setDetail", {
          data: wuliuData,
          id: editingWuliuId || 0
        });
        
        // Refresh Wuliu list first
        await this.getProductWulius();
        
        // Calculate and save Product totals
        this.calculateProductTotals();
        console.log("Saving Product totals with productId:", productId, this.currentItem);
        await this.$store.dispatch("product/setDetail", {
          'data': {...this.currentItem, ID: productId},
          'id': productId
        });
        
        sendSuccessNotice(editingWuliuId ? "Đã cập nhật mã Wuliu" : "Đã thêm mã Wuliu vào mã bốc");
        this.dialogWuliu = false;
        this.editingWuliuId = null;
        
        if (isNewProduct) {
          this.$router.push({ name: 'ProductDetail', params: { Pid: productId } });
        }
        this.getDetail(); // Refresh product details to update totals
      } catch (err) {
        sendErrorNotice("Lỗi khi " + (editingWuliuId ? "cập nhật" : "tạo") + " mã Wuliu / " + (editingWuliuId ? "更新" : "创建") + " 运单号时出错: " + (err.message || err));
      }
    },
    async getProductWulius() {
      if (this.currentItem && this.currentItem.ID) {
        await this.$store.dispatch("product/getWuliuList", this.currentItem.ID);
      }
    },
    async getSystemLogs() {
      if (!this.currentItem || !this.currentItem.ID) {
        this.systemLogs = [];
        return;
      }
      
      this.loadingLogs = true;
      try {
        const param = {
          pagination: { page: 1, itemsPerPage: 100, sortBy: ['id'], sortDesc: [true] },
          filter: [
            { column: 'function_name', value: 'Hàng lô/nhập kho TQ', condition: 's_equal' },
            { column: 'object_id', value: this.currentItem.ID, condition: 'equal' }
          ]
        };
        
        const response = await this.$store.dispatch("systemLog/getList", param);
        this.systemLogs = this.$store.state.systemLog.all.data || [];
      } catch (err) {
        console.error('Error loading system logs:', err);
        this.systemLogs = [];
      } finally {
        this.loadingLogs = false;
      }
    },
    async deleteWuliu(wuliuId) {
      try {
        await this.$store.dispatch("product/removeWuliu", {
          productId: this.currentItem.ID,
          wuliuId: wuliuId
        });
        
        // Refresh Wuliu list first
        await this.getProductWulius();
        
        // Calculate and save Product totals
        this.calculateProductTotals();
        await this.$store.dispatch("product/setDetail", {
          'data': {...this.currentItem},
          'id': this.currentItem.ID
        });
        
        sendSuccessNotice("Đã xóa mã Wuliu");
        this.getDetail();
      } catch (err) {
        sendErrorNotice("Lỗi khi xóa mã Wuliu / 删除运单号时出错: " + (err.message || err));
      }
    },
    saveData() {
      if (!this.$refs.productForm.validate()) {
        sendErrorNotice("Vui lòng nhập đầy đủ thông tin bắt buộc / 请填写完整必填信息");
        return;
      }
      //if (!this.selectedProductType) {
      // sendErrorNotice("Vui lòng chọn loại hàng hợp lệ");
      //  return;
      //}
      if(this.selectedProductType) {
        const minWeightCost = Number(this.selectedProductType.WeightCost || 0);
        const minVolumeCost = Number(this.selectedProductType.VolumeCost || 0);
        const weightPrice = Number(this.currentItem.WeightPrice || 0);
        const volumePrice = Number(this.currentItem.VolumePrice || 0);

        if (weightPrice > 0 && weightPrice < minWeightCost) {
          sendErrorNotice(`Giá cân phải lớn hơn hoặc bằng giá gốc (${minWeightCost}) / 重量单价必须大于或等于基础价 (${minWeightCost})`);
          return;
        }

        if (volumePrice > 0 && volumePrice < minVolumeCost) {
          sendErrorNotice(`Giá khối phải lớn hơn hoặc bằng giá gốc (${minVolumeCost}) / 体积单价必须大于或等于基础价 (${minVolumeCost})`);
          return;
        }
      }

      if(!(this.adminRole || this.currentItem.Status < this.product_status.da_xuat_kho)) {
        sendErrorNotice("Bạn không có quyền chỉnh sửa mã bốc này / 您没有权限编辑此装货编号");
        return;
      }
      this.calculateProductTotals();
      this.$store.dispatch("product/setDetail", {
        'data': {...this.currentItem},
        'id': this.currentItem.ID
      }).then(() => {
        sendSuccessNotice("Đã lưu thành công");
        if (!this.currentItem.ID) {
          window.getApp.$emit("APP_NAVIGATE", "ProductList");
        }
      });
    },
    exportData() {
      // Export functionality if needed
    },
  },
  mounted() {
    this.$store.dispatch("productType/getList");
    this.getDetail();
    
    this.$root.$on("REQUEST_REFRESH_DATA", this.getDetail);
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$on("REQUEST_CREATE_DATA", this.exportData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.getDetail);
    this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$off("REQUEST_CREATE_DATA", this.exportData);
  },
};
</script>
